import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MultiselectItem, Multiselect } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

export enum TranslationAttributePrefix {
  all = "",
  image = "IMG_",
  imageFamily = "IMG_FAMILY", // Ok senza _ finale
  pdf = "PDF_",
  pdfImgProduct = "PDF_IMG_PRODUCT",
  pdfImgFamily = "PDF_IMG_FAMILY",
  family = "FAMILY",
  widget = "WIDGET_" // [SCBMP-T808] configurazione dei widget partner sulla famiglia
}

@Component({
  selector: 'sacbo-translation-attribute-select',
  templateUrl: './translation-attribute-select.component.html',
  styleUrls: ['./translation-attribute-select.component.scss']
})
export class TranslationAttributeSelectComponent implements OnInit {

  @Input() set prefixAttributes(newValue: TranslationAttributePrefix[]) {
    this._prefixAttributes = newValue;
    this.loadMultiselectItems();
  }

  @Input() excludedAttributes: string[];
  @Input() attributeSelected: MultiselectItem[] = [];

  @Output() attributeSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  attributeList: MultiselectItem[] = [];

  private _prefixAttributes: TranslationAttributePrefix[] = [TranslationAttributePrefix.all];

  constructor(
    private portalService: PortalService,
  ) { }

  ngOnInit() {
    this.loadMultiselectItems();
  }

  loadMultiselectItems(): void {

    this.portalService.getMultiselectItems(Multiselect.TRANSLATION_ATTRIBUTE).subscribe((response) => {
      const { data } = response;

      const allAttributes = this.portalService.getItemsFromDataNoId(data);

      let itemsAllowed: MultiselectItem[] = [];

      this._prefixAttributes.forEach(prefix => {
        const filtered = allAttributes.filter(att => att.itemName.startsWith(prefix));
        itemsAllowed = itemsAllowed.concat(filtered);
      });

      this.attributeList = itemsAllowed;

      if (this.excludedAttributes && this.excludedAttributes.length) {
        this.removeExcludedItems();
      }

    });

  }

  /** Removal of unrequired prefixes from attributeList select */
  removeExcludedItems(): void {
    this.attributeList = this.attributeList.filter(a => !(this.excludedAttributes.findIndex(ex => a.itemName.includes(ex)) >= 0));
  }

  onAttributeSelect(): void {
    this.attributeSelectedChange.emit(this.attributeSelected);
    this.onSelected.emit(this.attributeSelected);
  }

}
